import ApiService from './ApiService'
import { UserResponse, UpdateUserRequest, ChangePasswordRequest, SaveGitHubTokenRequest } from "@/@types/user";

export async function apiGetUserInfo() {
  return ApiService.fetchData<UserResponse>({
    url: '/api/users/info',
    method: 'get',
  })
}

export async function apiGetUserHasToken() {
  return ApiService.fetchData<boolean>({
    url: '/api/users/has_token',
    method: 'get',
  })
}

export async function apiUpdateUserInfo(
  data: UpdateUserRequest
) {
  return ApiService.fetchData<UserResponse>({
    url: `/api/users/update`,
    method: 'put',
    data,
  })
}

export async function apiSaveUserToken(
  data: SaveGitHubTokenRequest
) {
  return ApiService.fetchData<UserResponse>({
    url: `/api/users/save_token`,
    method: 'put',
    data,
  })
}

export async function apiChangePasswordInfo(
  data: ChangePasswordRequest
) {
  return ApiService.fetchData<UserResponse>({
    url: `/api/users/change_password`,
    method: 'put',
    data,
  })
}
